const allModules = {
  utilization: 'utilization',
  healthCheckup: 'healthCheckup',
  drConsultation: 'drConsultation',
  hra: 'hra',

  engagement: 'engagement',

  analytics: 'analytics',
  healthRisks: 'healthRisks',
  testResult: 'testResult',

  manageEmployee: 'manageEmployee',
  ohcManagement: 'ohcManagement',

  help: 'help',
  profile: 'profile',
  setting: 'setting',
} as const;

export type ModuleName = keyof typeof allModules;
export default allModules;
